const editSearchButton = document.getElementById('catf_edit_search_button');

/**
 *
 *
 *
 */
const init = function() {

  if ( editSearchButton ) {

    const buttonSpan = editSearchButton.querySelector('span');
    const originalButtonText = buttonSpan.innerText;
    const parentElement = editSearchButton.parentElement;

    editSearchButton.addEventListener( 'click', () => {

      const expanded = editSearchButton.getAttribute('aria-expanded');

      console.log( expanded );
      
      if ( expanded === 'true' ) {
        parentElement.classList.remove('show-form');
        editSearchButton.setAttribute( 'aria-expanded', 'false' );
        buttonSpan.innerText = originalButtonText;
      } else {
        parentElement.classList.add('show-form');
        editSearchButton.setAttribute( 'aria-expanded', 'true' );
        buttonSpan.innerText = 'Hide form';        
      }

    } );

  }

};


const api = {
	init: init
};

export default api;